export function actionIcon(type) {
  const paths = {
    view: (
      <>
        <path d={"M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12Z"}></path>
        <circle cx={"12"} cy={"12"} r={"3"}></circle>
      </>
    ),
    edit: <path d={"m16 3 5 5-12 12-6 1 1-6Z M14 5l5 5"}></path>,
    delete: (
      <path d={"M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"}></path>
    ),
    archive: <path d={"M3 3h18v5H3zM5 8v13h14V8M9 12h6"}></path>,
  };
  return (
    <svg
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.7"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
      aria-hidden={"true"}
    >
      {paths[type]}
    </svg>
  );
}
